module.exports = __webpack_public_path__ + "static/recurve-bow-5d5c9ebc2daa7126e3f954e63546fa44.png";